import { useMutation, useQueryClient } from "react-query";

import { getQuickRepliesQueryKey } from "api/services/messaging/hooks/useGetQuickReplies";
import type { DeleteQuickReplyArgs, QuickReply } from "api/services/messaging/schemas/quick_replies";
import { useApiClient } from "api/useApiClient";

export const useDeleteQuickReply = () => {
  const queryClient = useQueryClient();
  const client = useApiClient();

  return useMutation(({ id, userID }: DeleteQuickReplyArgs) => client.deleteQuickReply({ id, userID }), {
    onMutate: async (deleteQuickReply: DeleteQuickReplyArgs) => {
      const queryKey = getQuickRepliesQueryKey(deleteQuickReply.userID);

      await queryClient.cancelQueries(queryKey);
      const previousQuickReplies = queryClient.getQueryData<QuickReply[]>(queryKey);

      if (previousQuickReplies) {
        queryClient.setQueryData<QuickReply[]>(
          queryKey,
          previousQuickReplies.filter(quickReply => quickReply.id !== deleteQuickReply.id)
        );
      }

      return { previousQuickReplies };
    },
    onError: (error, variables, context) => {
      const queryKey = getQuickRepliesQueryKey(variables.userID);

      if (context?.previousQuickReplies) {
        queryClient.setQueryData<QuickReply[]>(queryKey, context.previousQuickReplies);
      }
    },
    onSettled: context => {
      if (context) {
        queryClient.invalidateQueries(getQuickRepliesQueryKey(context.user_id));
      }
    },
  });
};
